import React from 'react'
import PropTypes from 'prop-types'

import { optionListItemStyle, hiddenAnchorStyle } from './styles'

import RadioInput from './RadioInput'

const OptionListItemRadio = ({ id, isSelected, onClick, label, children }) => (
  <div key={id} style={optionListItemStyle}>
        <div onClick={(e) => { e.preventDefault(); onClick(id); }}>
            <RadioInput className='mr-2' selected={isSelected} onClick={() => onClick(id)} />
      <a href='' style={hiddenAnchorStyle}>{label}</a>
    </div>
    {children}
  </div>);

OptionListItemRadio.propTypes = {
  isSelected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired
}

export default OptionListItemRadio